import axios from "axios";
import { getToken, getTokenHeader } from "../../../../../screen/auth/action";
import { manufactureLeadGeneratedUrl, manufactureRoleMapUrl } from "../urls";

export const deleteMRMAction = async (payload = {}) => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.delete(manufactureRoleMapUrl(), {
        ...getTokenHeader(token),
        data: payload,
      });
      return next(response.data);
    } catch (err) {
      return next({ 
        error: true, 
        message: err.response?.data?.message || 'Failed to delete role' 
      });
    }
  });
};
export const deleteLeadGeneratedAction = async (lead_generation_id) => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.delete(`${manufactureLeadGeneratedUrl()}?lead_generation_id=${lead_generation_id}`, {
        ...getTokenHeader(token),
      });
      return next(response.data);
    } catch (err) {
      return next({ 
        error: true, 
        message: err.response?.data?.message || 'Failed to delete role' 
      });
    }
  });
};

export const updateMRMAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .put(manufactureRoleMapUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
          return next(data);
      })
      .catch((err) => {
          return err;
      });
    });
};
